import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

export const enum Event {
  CardView = 'product-mvc-card_view',
  CardClick = 'product-mvc-card_click',
  DrawerClick = 'mvc-drawer_click',
  Click = 'product-mvc-buttons_click',
  View = 'product-mvc-buttons_view',
}

const enum Element {
  Icon = 'icon',
  Checkbox = 'checkbox',
  Button = 'button',
}

const enum Interaction {
  Close = 'close',
  Save = 'save',
}

export const dispatchMVCCardViewEvent = () =>
  dispatchTrackingEventGA4({
    event: Event.CardView,
  });

export const dispatchMVCCardClickEvent = (title: string) =>
  dispatchTrackingEventGA4({
    event: Event.CardClick,
    title,
  });

export const dispatchProductVariantClickEvent = (
  title: string,
  listLength: number,
  listPosition: number
) =>
  dispatchTrackingEventGA4({
    event: Event.DrawerClick,
    element: Element.Checkbox,
    title,
    list_length: listLength,
    list_position: listPosition,
  });
export const dispatchSaveButtonClickEvent = () =>
  dispatchTrackingEventGA4({
    event: Event.DrawerClick,
    interaction: Interaction.Save,
    element: Element.Button,
  });

export const dispatchCloseIconClickEvent = () =>
  dispatchTrackingEventGA4({
    event: Event.DrawerClick,
    element: Element.Icon,
    interaction: Interaction.Close,
  });
